import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBloodPressure = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1,.cls-2{fill:none;stroke:currentColor;stroke-width:1.5px;}.cls-1{stroke-miterlimit:10;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:currentColor;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M15,14v3.5A3.5,3.5,0,0,1,11.5,21h0A3.5,3.5,0,0,1,8,17.5V12"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-1",
			d: "M8,12V10A2,2,0,0,0,6,8H6a2,2,0,0,0-2,2v2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-2",
			cx: 18,
			cy: 8,
			r: 3
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-2",
			cx: 3.5,
			cy: 13.5,
			r: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-3",
			cx: 18,
			cy: 8,
			r: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "M21,8a3,3,0,0,0-2.5-2.95V4.5a1,1,0,0,0-1-1h-5a1,1,0,0,0-1,1V13a1,1,0,0,0,1,1h5a1,1,0,0,0,1-1V11A3,3,0,0,0,21,8Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "cls-3",
			x: 17.11,
			y: 6.69,
			width: 1,
			height: 2,
			rx: .5,
			transform: "translate(0.66 16.73) rotate(-51.67)"
		})
	]
});
export default SvgBloodPressure;
